import type { ColumnDef } from '@tanstack/react-table'
import { Link } from '@inertiajs/react'
import type CrmFundraisingPaymentMethod from '@/types/serializers/CrmFundraisingPaymentMethod'
import { PaymentMethodActions } from './PaymentMethodActions'

export const paymentMethodColumns: ColumnDef<CrmFundraisingPaymentMethod, unknown>[] = [
  {
    accessorKey: 'name',
    header: 'Nom',
    // Archived rows link nowhere: the show route is kept-only, so a link on a
    // discarded row would 404. Render plain text until it is restored.
    cell: ({ row }) =>
      row.original.discarded ? (
        <span className="font-medium">{row.original.name}</span>
      ) : (
        <Link
          href={`/fundraising/payment_methods/${row.original.id}`}
          className="font-medium text-primary hover:underline"
        >
          {row.original.name}
        </Link>
      ),
  },
  {
    accessorKey: 'code',
    header: 'Code',
    cell: ({ row }) => (
      <span className="font-mono text-xs">
        {row.original.code ?? '-'}
      </span>
    ),
  },
  {
    accessorKey: 'position',
    header: 'Position',
    cell: ({ row }) => row.original.position,
  },
  {
    id: 'actions',
    header: '',
    cell: ({ row }) => <PaymentMethodActions method={row.original} />,
  },
]
